// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { paymentProfileBillingAddressStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PaymentProfileBillingAddress";
import { addressWrapper } from "@monsma/App/WidgetExtensions/Addresses/SharedAddressesComponentsStylesExtension";
import { css } from "styled-components";

paymentProfileBillingAddressStyles.wrapper = addressWrapper;
paymentProfileBillingAddressStyles.label = {
    weight: 600,
    css: css`
        margin-right: 2px;
    `,
};
